// extracted by mini-css-extract-plugin
export default {"dlScreenSwitcher":"src-js-containers-auto_layout-components-ScreenSwitcher---dlScreenSwitcher---yjepu"};